<template>
  <div id="program">
    <div class="fixed-content">
      <page-section title="Le programme SPIADI 2026">
        <div class="row">
          <div class="col-xs-12 col-md-8 col-md-offset-2 text-justify">
            <p class="introduction">
              Diminuer le nombre des infections associées aux dispositifs invasifs est une
              priorité nationale.
            </p>
            <p class="introduction">
              Une stratégie associant les 4 volets
              <strong>Surveillance</strong>,
              <strong>Observation&nbsp;des&nbsp;pratiques</strong>,
              <strong>Analyse&nbsp;des&nbsp;causes</strong> et
              <strong>Formation</strong> permet de
              réduire de façon significative les infections liées à
              leur utilisation.
            </p>
          </div>
          <div class="col-xs-12 col-sm-6 col-sm-offset-3 col-md-8 col-md-offset-2">
            <div class="panel panel-success panel-main">
              <div class="panel-heading text-center">
                <div class="panel-title">
                  <h3>SPIADI 2026</h3>
                </div>
              </div>
              <div class="panel-body introduction">
                <p>
                  Les inscriptions au programme 2026 sont ouvertes et se
                  font directement à partir de votre
                  <router-link to="/establishments/list" tag="a">
                    espace SPIADI
                  </router-link>.
                </p>
                <p>
                  Les guides, fiches et annexes 2026 sont téléchargeables ci-dessous.
                </p>
                <link-block plink="documents/spiadi/SPIADI2026.pdf"
                            v-show="false"
                            description="SPIADI2026.pdf"
                            title="Guide complet SPIADI 2026"
                            class="fb-reaInfADI"
                            text="Bientôt disponible"
                            :icon="'notebook'">
                </link-block>
              </div>
            </div>
          </div>
        </div>
      </page-section>
    </div>
    <div class="program-nav fixed-content">
      <span class="program-nav-background" v-sticky>
        <div class="row">
          <div class="col-xs-12 col-lg-10 col-lg-push-1">
            <div class="program-nav-container">
              <div :key="`target-${k}`" class="program-nav-detail"
                                        v-for="(v, k) in targets">
                <btn block
                     :type="v.style"
                     size="lg"
                     :active="k === target"
                     @click="select(k)">
                  <strong>
                    <span class="hidden-xs hidden-sm">{{ v.title }}</span>
                    <span class="visible-xs visible-sm">{{ v.short }}</span>
                  </strong>
                </btn>
              </div>
            </div>
          </div>
        </div>
      </span>

      <div class="row">
        <div class="text-center col-xs-12 col-lg-10 col-lg-push-1">
          <div class="program-detail-container">
            <div class="program-detail"
                 :key="`target-${k}`"
                 v-for="(v, k) in targets">
              <div class="program-nav-btn">
                <btn block :type="v.style" size="lg" :active="k === target"
                     @click="select(k)">
                  <strong>
                    {{ v.title }}
                  </strong>
                </btn>
              </div>
              <div class="text-center text-justify program-description">
                <p v-html="v.description">
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span ref="scrollAnchor"></span>
    <div :is="target" v-if="target">
    </div>
  </div>
</template>

<script>
import presentation from '@/views/presentation'
import observation from '@/views/observation'
import cause from '@/views/cause'
import training from '@/views/training'
import pageSection from '@/components/pagesection'
import linkBlock from '@/components/linkBlock'

const targets = {
  presentation: {
    title: 'Surveillance',
    short: 'Surveillance',
    style: 'bactADI',
    description: `
La <strong>surveillance</strong> des infections permet de
connaître l’incidence des bactériémies liées à un cathéter
au sein des services participant, et de confronter ces
résultats à ceux obtenus pour de services semblables ;
le feed-back rapide des résultats aux équipes de terrain
permet de créer une dynamique pour l’amélioration
    `
  },

  observation: {
    title: 'Observation des pratiques',
    short: 'Pratiques',
    style: 'observa4',
    description: `
L’<strong>observation des pratiques</strong> permet
d’identifier les écarts avec les recommandations, et l’analyse
des écarts et des freins au respect des bonnes pratiques
permet de définir les besoin en formation
`
  },

  cause: {
    title: 'Analyse des causes',
    short: 'Causes',
    style: 'badiCause',
    description: `
L’<strong>analyse des causes</strong> d'une bactériémie liée
à un cathéter permet de repérer et comprendre l'évènement,
en tirer des enseignements pour l'avenir et contribuer à éviter
que l'infection se reproduise
    `
  },

  training: {
    title: 'Formation',
    short: 'Formation',
    style: 'temporary',
    description: `
La <strong>formation</strong> des professionnels de
santé en charge de la pose et des manipulations des lignes
associées aux dispositifs invasifs permet d’améliorer
les pratiques, et de prévenir les infections liées à un cathéter
    `

  }
}

export default {
  name: 'program',

  data () {
    const routeTarget = this.$route.query.target
    const target = targets[routeTarget] == null ? 'presentation' : routeTarget
    return {
      targets,
      target
    }
  },

  methods: {
    select: function (t) {
      this.target = t
      const rect = this.$refs.scrollAnchor.getBoundingClientRect()
      const top = rect.top + window.pageYOffset ||
                  document.documentElement.scrollTop
      const offset = -40

      this.$nextTick(
        () => { window.scrollTo(0, top + offset) }
      )
    }
  },

  components: {
    'presentation': presentation,
    'observation': observation,
    'cause': cause,
    'training': training,
    'page-section': pageSection,
    'link-block': linkBlock
  }
}
</script>

<style scoped lang="less">
@import '~variables';

.program-nav-container, .program-detail-container {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
}

.program-detail-container {
  margin-top: 4rem;
}

@media (min-width: 0) and (max-width: @screen-xs-max) {
  .program-nav-container {
    gap: 0rem;
  }
}

.program-nav-detail, .program-detail {
  flex-basis: 23%;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

@media (min-width: 0) and (max-width: @screen-xs-max) {
  .program-detail {
    flex-basis: 100%;
  }
}

@media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {
  .program-detail {
    flex-basis: 48%;
  }
}

.program-nav {
  background-color: @dark-base;
  padding: 0.4rem;
}

.program-nav-background {
  background-color: @dark-base;
  width: 100%;
  padding-bottom: 0.4rem;

  .btn {
    display: none;
  }

  @media (min-width: 0) and (max-width: @screen-xs-max) {
    font-size: 80%;
  }
}

.program-nav-background.top-sticky {
  .btn {
    display: block;
    margin-top: 0.4rem;
  }
}

.program-description {
  margin-top: 2rem;
  padding-bottom: 3rem;
  color: white;

  p {
    font-size: 110%;
  }
}

.introduction {
  font-size: 140%;
}

.panel .link-block {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.panel-main {
  margin-top: 2rem;

  .panel-title h3 {
    color: white;
  }
}
</style>
